import React from 'react';

interface Props {
	text?: string;
	fontFamily?: string;
	textColor?: string;
	children?: React.ReactElement;
}

export const WidgetListItem = (props: Props): React.ReactElement => {
	const { text, textColor, fontFamily, children } = props;

	return (
		<li
			className="ui-widget-list-item no-bottom-margin"
			style={{ color: `${textColor}`, fontFamily: `${fontFamily}` }}
		>
			{text || children}
		</li>
	);
};
